import "./portfolio.css";

import amp from "../../assets/Amplify-Email.63fbb22a.png";

import edFacts from "../../assets/edFacts.png";

import map from "../../assets/map.png";
import daisy from "../../assets/daisy.png";
import preFlight from "../../assets/pre-flight.png";
import leo from "../../assets/leo.png";
const Portfolio = () => {
  return (
    <section id="portfolio">
      <h2 className="portHeading">My explorations and experiments</h2>
      <div className="portLayout">
        <div className="column">
          {/* Daiy Health Card */}
          <div className="card">
            <div className="cardImg">
              <img src={daisy} alt="project yellow daisy logo" />
            </div>
            <div className="cardDesc">
              <span className="projectTitle">RAG with MCP : Daisy Health</span>
              <p className="projectP">
                {" "}
                An agentic AI system for HR policy and operations tasks at Daisy
                Health. The system combines Retrieval-Augmented Generation (RAG)
                over internal HR policy documents with an agentic orchestrator
                that plans, selects tools, and calls a Model Context Protocol
                (MCP) server to complete multi-step HR workflows. Please note
                this version is hosted on a free tier and needs time to wake up
                the servers!{" "}
              </p>
              <div className="tags">
                <div className="tag">RAG</div>
                <div className="tag">MCP</div>
                <div className="tag">Python</div>
              </div>
              <div className="links">
                <a
                  href="https://github.com/Alex-is-Gonzalez/Daisy_Health"
                  className="cardLink"
                >
                  Review repo
                </a>
                <a
                  href="https://daisy-health-streamlit.onrender.com/"
                  className="cardLink"
                >
                  View site
                </a>
              </div>
            </div>
          </div>
          {/* Teach Card */}
          <div className="card">
            <div className="cardImg">
              <img src={edFacts} alt="" />
            </div>
            <div className="cardDesc">
              <span className="projectTitle">
                {" "}
                Data Visualization : Ed facts
              </span>
              <p className="projectP">
                This application leverages data from the Urban Institute's
                Education Data Portal to generate intuitive and digestible
                graphs. Built with React and styled using Tailwind CSS, it
                provides a user-friendly interface for visualizing educational
                data. Currently, the application is optimized for desktop use.
                Please note that the API can experience some latency.
              </p>
              <div className="tags">
                <div className="tag">React</div>
                <div className="tag">API</div>
                <div className="tag">Tailwind CSS</div>
              </div>
              <div className="links">
                <a
                  href="https://github.com/Alex-is-Gonzalez/edFacts"
                  className="cardLink"
                >
                  Review repo
                </a>
                <a href="https://ed-facts.vercel.app/" className="cardLink">
                  View site
                </a>
              </div>
            </div>
          </div>

          {/* MTA Card */}
          <div className="card">
            <div className="cardImg">
              <img src={map} alt="MTA Routes Images" />
            </div>
            <div className="cardDesc">
              <span className="projectTitle">Real Time MTA Bus Tracker</span>
              <p className="projectP">
                {" "}
                Track real time buses using data from MBTA with this code. The
                page updates the buses' location every 15 seconds. The red and
                blue bus icons represent opposite directions of travel.
              </p>
              <div className="tags">
                <div className="tag">JavaScript</div>
                <div className="tag">Google API</div>
                <div className="tag">MTA API</div>
              </div>
              <div className="links">
                <a
                  href="https://github.com/Alex-is-Gonzalez/Real-Time-Bus-Tracker"
                  className="cardLink"
                >
                  Review repo
                </a>
                {/* <a href="https://amplify-app-production.herokuapp.com/" className="cardLink">View Site</a> */}
              </div>
            </div>
          </div>
        </div>
        <div className="column">
          {/* Amplify Card */}
          <div className="card">
            <div className="cardImg">
              <img src={amp} alt="" />
            </div>
            <div className="cardDesc">
              <span className="projectTitle">Open Source : Amplify</span>
              <p className="projectP">
                Amplify is an Open-Source project in the civic-tech space.
                Amplify allows users to find their represenatives in their
                current area of residency, then they are able to fill out a
                letter to send to their represenative. Amplify takes care of
                mailing out the letter!{" "}
              </p>
              <div className="tags">
                <div className="tag">Vue</div>
                <div className="tag">Git Actions</div>
                <div className="tag">Heroku</div>
              </div>
              <div className="links">
                <a
                  href="https://github.com/ProgramEquity/amplify"
                  className="cardLink"
                >
                  Review repo
                </a>
                <a href="https://programearth.org/" className="cardLink">
                  View site
                </a>
              </div>
            </div>
          </div>
          {/* Leo's Card  */}
          <div className="card">
            <div className="cardImg">
              <img src={leo} alt="leo with a shopping cart logo" />
            </div>
            <div className="cardDesc">
              <span className="projectTitle">
                {" "}
                Interactive Learning: Advance Calculus
              </span>
              <p className="projectP">
                A FullStack aplication for ordering food that uses Next JS as
                the front end framework and MongoDB Atlas as the backend. In
                order to communicate from the front and back seemlessly Apollo
                and GraphQL were used. In addition this application uses Stripe
                as it's payment platform.
              </p>
              <div className="tags">
                <div className="tag">Multivariable Functions</div>
                <div className="tag">React</div>
                <div className="tag">Compuational Graphs</div>
              </div>
              <div className="links">
                <a
                  href="https://github.com/Alex-is-Gonzalez/intro_to_Math"
                  className="cardLink"
                >
                  Review repo
                </a>
                <a
                  href="https://intro-to-math.vercel.app/"
                  className="cardLink"
                >
                  View Site
                </a>
              </div>
            </div>
          </div>

          {/* RFBL Card */}
          <div className="card">
            <div className="cardImg">
              <img src={preFlight} alt="Alex Bitmojii with checkmark" />
            </div>
            <div className="cardDesc">
              <span className="projectTitle">
                Interactive Learning : Module Pre-React{" "}
              </span>
              <p className="projectP">
                Part of the interactive learning suite I built for Snap Inc.
                This site covers the syntax rules that trip people up in their
                first React lesson. Each drill is broken on purpose. The goal is
                the identitfy the issue in the broken code on the left hand
                side. Then in "your fix section" fix the broken code.{" "}
              </p>
              <div className="tags">
                <div className="tag">React</div>
                <div className="tag">Javascript</div>
                <div className="tag">HTML</div>
              </div>
              <div className="links">
                {/* <a href="https://github.com/ProgramEquity/amplify" className="cardLink">Review Repo</a> */}
                {/* <a
                  href="https://rightsforbetterlifecom.wordpress.com/"
                  className="cardLink"
                >
                  View site
                </a> */}
                <a
                  href="  https://fundamental-to-react-fc57e6e2l-alexisgonzalezs-projects.vercel.app/"
                  className="cardLink"
                >
                  View site
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="gitLink">
        <a href="https://github.com/Alex-is-Gonzalez" className="gitLinkA">
          View more experiments on GitHub
        </a>
      </div>
    </section>
  );
};

export default Portfolio;
